import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "layout-navbar navbar navbar-expand-xl align-items-center bg-navbar-theme",
  id: "layout-navbar"
}
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "layout-menu-toggle navbar-nav align-items-xl-center me-3 me-xl-0 d-xl-none" }, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "nav-item nav-link px-0 me-xl-4",
    href: "javascript:void(0)"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "bx bx-menu bx-sm" })
  ])
], -1)
const _hoisted_4 = {
  class: "navbar-nav-right d-flex align-items-center",
  id: "navbar-collapse"
}
const _hoisted_5 = { class: "navbar-nav flex-row align-items-center ms-auto" }
const _hoisted_6 = { class: "nav-item navbar-dropdown dropdown-user dropdown" }
const _hoisted_7 = {
  class: "nav-link dropdown-toggle",
  href: "javascript:void(0);",
  "data-bs-toggle": "dropdown"
}
const _hoisted_8 = { class: "avatar" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "dropdown-menu dropdown-menu-end" }
const _hoisted_11 = {
  class: "dropdown-item",
  href: "#"
}
const _hoisted_12 = { class: "d-flex" }
const _hoisted_13 = { class: "flex-shrink-0 me-3" }
const _hoisted_14 = { class: "avatar" }
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "flex-grow-1" }
const _hoisted_17 = { class: "fw-semibold d-block lh-1" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("small", null, "Customer", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "dropdown-divider" })
], -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("i", { class: "bx bx-user me-2" }, null, -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "align-middle" }, "My Profile", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("i", { class: "bx bx-power-off me-2" }, null, -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "align-middle" }, "Log Out", -1)
const _hoisted_24 = [
  _hoisted_22,
  _hoisted_23
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("ul", _hoisted_5, [
          _createElementVNode("li", _hoisted_6, [
            _createElementVNode("a", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("img", {
                  src: _ctx.url + 'assets/img/customer-portal/icon-user.png',
                  alt: "User",
                  width: "18",
                  height: "18"
                }, null, 8, _hoisted_9)
              ]),
              _createElementVNode("span", null, _toDisplayString(_ctx.customerName), 1)
            ]),
            _createElementVNode("ul", _hoisted_10, [
              _createElementVNode("li", null, [
                _createElementVNode("a", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("img", {
                          src: _ctx.url + 'assets/img/customer-portal/icon-user.png',
                          alt: "User",
                          width: "18",
                          height: "18"
                        }, null, 8, _hoisted_15)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.customerName), 1),
                      _hoisted_18
                    ])
                  ])
                ])
              ]),
              _hoisted_19,
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, {
                  to: { name: 'CustomerProfile' },
                  class: "dropdown-item"
                }, {
                  default: _withCtx(() => [
                    _hoisted_20,
                    _hoisted_21
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  class: "dropdown-item cursor-pointer",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
                }, _hoisted_24)
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}